import React from "react";
import isEmpty from "lodash/isEmpty";
import Icon from "wonderbly-components/lib/Icon";
import PropTypes from "prop-types";
import { allowEdit } from "../../../CartItems/LineItem/helpers";

const EditableLinks = (props) => {
  const hasGiftwrapAddons = !isEmpty(props.giftwrapAddons);
  const hasExtraAddons = !isEmpty(props.extraAddons);

  return (
    <div className="line-item-ii-links">
      {/* Removing th edit button for my-golden-ticket and the-littlest-bear until the edit issue is resolved */}
      {allowEdit(props) && (
        <a
          href={props.editUrl}
          className="line-item-ii-edit line-item-ii-edit--preview"
          onClick={props.onClickLink.editItem}
        >
          <Icon icon="write" /> {props.editItemCta}
        </a>
      )}
      {props.product?.formats?.enabled && allowEdit(props) && (
        <a
          href={props.editFormatUrl}
          className="line-item-ii-edit line-item-ii-edit--format"
          onClick={props.onClickLink.editItem}
        >
          <Icon icon="book" /> {props.editFormatCta}
        </a>
      )}
      {props.giftwrapCta && !props.isEnableUpsell && (
        <a
          href={props.editGiftwrapUrl}
          className="line-item-ii-edit line-item-edit--giftwrap"
          onClick={
            props.onClickLink[hasGiftwrapAddons ? "editAddons" : "addAddons"]
          }
        >
          <Icon icon="gift" />{" "}
          {props.giftwrapCta[hasGiftwrapAddons ? "edit" : "add"]}
        </a>
      )}
      {props.extrasCta && (
        <a
          href={props.editExtrasUrl}
          className="line-item-ii-edit line-item-edit--extras"
          onClick={
            props.onClickLink[hasExtraAddons ? "editAddons" : "addAddons"]
          }
        >
          <Icon icon="star" />{" "}
          {props.extrasCta[hasExtraAddons ? "edit" : "add"]}
        </a>
      )}
    </div>
  );
};

EditableLinks.propTypes = {
  giftwrapAddons: PropTypes.array,
  extraAddons: PropTypes.array,
  extrasCta: PropTypes.shape({
    add: PropTypes.string.isRequired,
    edit: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  giftwrapCta: PropTypes.shape({
    add: PropTypes.string.isRequired,
    edit: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  product: PropTypes.shape({
    formats: PropTypes.shape({
      enabled: PropTypes.bool,
    }),
  }),
  editItemCta: PropTypes.string,
  editFormatCta: PropTypes.string,
  isMobile: PropTypes.bool,
  onClickLink: PropTypes.shape({
    editItem: PropTypes.func.isRequired,
    editAddons: PropTypes.func.isRequired,
    addAddons: PropTypes.func.isRequired,
  }),
  editUrl: PropTypes.string.isRequired,
  editFormatUrl: PropTypes.string.isRequired,
  editGiftwrapUrl: PropTypes.string.isRequired,
  editExtrasUrl: PropTypes.string.isRequired,
  model: PropTypes.shape({
    countryModel: PropTypes.object,
  }),
  fallbackProduct: PropTypes.shape({
    response: PropTypes.object,
  }),
  isEnableUpsell: PropTypes.bool,
};

export default EditableLinks;
